import { render, staticRenderFns } from "./PaymentTypeForm.vue?vue&type=template&id=c487eb0a"
import script from "./PaymentTypeForm.vue?vue&type=script&lang=js"
export * from "./PaymentTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports